import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { NewProductsFilters } from "@/hooks/useNewProducts";

interface NewProductsFiltersProps {
  filters: NewProductsFilters;
  onFiltersChange: (filters: NewProductsFilters) => void;
}

export default function NewProductsFiltersComponent({
  filters,
  onFiltersChange,
}: NewProductsFiltersProps) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div className="flex flex-col gap-4 md:flex-row md:items-end">
        {/* Search Input */}
        <div className="relative w-full md:w-80">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            placeholder="Zoek op naam, artikelnummer of barcode..."
            value={filters.search}
            onChange={(e) =>
              onFiltersChange({ ...filters, search: e.target.value })
            }
            className="pl-10"
          />
        </div>

        {/* Date Filter */}
        <Select
          value={filters.dateFilter}
          onValueChange={(value: NewProductsFilters["dateFilter"]) =>
            onFiltersChange({ ...filters, dateFilter: value })
          }
        >
          <SelectTrigger className="w-full md:w-40">
            <SelectValue placeholder="Periode" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Alle</SelectItem>
            <SelectItem value="today">Vandaag</SelectItem>
            <SelectItem value="week">Deze week</SelectItem>
            <SelectItem value="month">Deze maand</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {/* Show Hidden Toggle */}
      <div className="flex items-center gap-2">
        <Switch
          id="show-hidden"
          checked={filters.showHidden}
          onCheckedChange={(checked) =>
            onFiltersChange({ ...filters, showHidden: checked })
          }
        />
        <Label htmlFor="show-hidden" className="cursor-pointer">
          Toon verborgen producten
        </Label>
      </div>
    </div>
  );
}
